import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 16.61V6.5l-4 4V6h-6.61zM3.41 1.86L2 3.27 4.73 6H3v12h13.73l3 3 1.41-1.41z"
}), 'VideocamOffSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VideocamOffSharp.js
// module id = 7054
// module chunks = 2